import { Flex } from "antd";
import LeftArrow from "../_icons/LeftArrow";
import RightIcon from "../_icons/RightIcon";

type NavigationButtonsProps = {
  onPrev: () => void;
  onNext: () => void;
  canGoPrev: boolean;
  canGoNext: boolean;
};

export default function NavigationButtons({
  onPrev,
  onNext,
  canGoPrev,
  canGoNext,
}: NavigationButtonsProps) {
  return (
    <Flex align="center" gap={16}>
      <button
        onClick={onPrev}
        disabled={!canGoPrev}
        className="text-theme-slate-400 disabled:text-theme-slate-100 disabled:cursor-not-allowed transition-colors hover:text-theme-slate-600"
        aria-label="পূর্ববর্তী পৃষ্ঠা"
      >
        <LeftArrow />
      </button>
      <button
        onClick={onNext}
        disabled={!canGoNext}
        className="text-theme-slate-400 disabled:text-theme-slate-100 disabled:cursor-not-allowed transition-colors hover:text-theme-slate-600"
        aria-label="পরবর্তী পৃষ্ঠা"
      >
        <RightIcon />
      </button>
    </Flex>
  );
}
